/* eslint-disable simple-import-sort/imports */
import React from 'react';
import { styled } from 'styled-components';

import { Reveal, Stagger, StaggerItem } from 'pages/HomeV2/components/Motion';
import {
  Container,
  Eyebrow,
  Lead,
  SectionHead,
  Title,
  v2,
} from 'pages/HomeV2/v2';

import { goodieTrust } from '../data-goodie';
import { ICONS } from '../icons';

const Wrapper = styled.section`
  position: relative;
  background: ${v2.bg};
  border-top: 1px solid ${v2.border};
  padding: clamp(72px, 9vw, 130px) 0;
`;

const Grid = styled(Stagger)`
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;

  @media (min-width: 560px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
  }
`;

const Item = styled(StaggerItem)`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 22px;
  border-radius: 18px;
  border: 1px solid ${v2.border};
  background: ${v2.surface};
  transition:
    border-color 0.3s ease,
    background 0.3s ease;

  @media (hover: hover) {
    &:hover {
      border-color: ${v2.borderStrong};
      background: ${v2.surfaceHover};
    }
  }

  h3 {
    font-family: ${v2.fontDisplay};
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
    color: ${v2.text};
    margin: 0 0 6px;
  }

  p {
    font-family: ${v2.fontBody};
    font-size: 14.5px;
    line-height: 1.6;
    color: ${v2.textMuted};
    margin: 0;
  }
`;

const IconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: ${v2.blueSoft};
  border: 1px solid rgba(30, 150, 252, 0.3);
  color: #5bb8ff;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const GoodieTrust = () => (
  <Wrapper aria-labelledby="goodie-trust-title">
    <Container>
      <SectionHead>
        <Reveal>
          <Eyebrow>Vertrauen</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <Title id="goodie-trust-title">
            Entwickelt für Zahnarztpraxen in{' '}
            <span className="grad">Deutschland</span>.
          </Title>
        </Reveal>
        <Reveal delay={0.2}>
          <Lead>
            Datenschutz, deutsche Abrechnungslogik und echte Praxiserfahrung –
            das ist die Basis, auf der FOXI entwickelt wird.
          </Lead>
        </Reveal>
      </SectionHead>

      <Grid gap={0.07}>
        {goodieTrust.map((item) => {
          const Icon = ICONS[item.icon];
          return (
            <Item key={item.title} y={22}>
              <IconBox aria-hidden>
                <Icon />
              </IconBox>
              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </Item>
          );
        })}
      </Grid>
    </Container>
  </Wrapper>
);

export default GoodieTrust;
